import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
};

const setData = (store, data) => {
  store.setState((state) => {
    state.cuenta.sucursal.upsert.data = { ...data };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.cuenta.sucursal.upsert = { ...state.cuenta.sucursal.upsert, ...data };
  });
};

const upsert = async (store, meta, id) => {
  store.setState((state) => {
    state.cuenta.sucursal.upsert.busy = true;
    state.cuenta.sucursal.upsert.error = undefined;
    state.cuenta.sucursal.upsert.result = undefined;
  });

  try {
    let body = {
      ...meta,
    };

    let response = {};

    if (!!id) {
      response = await Http.put(`api/catalogos/sucursal/${id}`, {
        ...body,
      });
    } else {
      response = await Http.post(`api/catalogos/sucursal`, {
        ...body,
      });
    }

    store.setState((state) => {
      state.cuenta.sucursal.upsert.busy = false;
      state.cuenta.sucursal.upsert.data = response.data;
      state.cuenta.sucursal.upsert.result = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.cuenta.sucursal.upsert.busy = false;
      state.cuenta.sucursal.upsert.error = error.data || error;
    });
  }
};

const resetError = (store) => (state) => {
  state.cuenta.sucursal.upsert.error = undefined;
};

const reset = (store) => (state) => {
  state.cuenta.sucursal.upsert = { ...initialState };
};

const actions = {
  setData,
  change,
  upsert,
  resetError,
  reset,
};

const SucursalUpsertStore = {
  state: () => initialState,
  actions,
};

export default SucursalUpsertStore;
